import { takeLatest, put, call } from 'redux-saga/effects';
import * as CommonCaseActions from './action';
import { CORE_API, REPORT } from '../../../config';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../../constants';
import request from '../../../components/Utils/httpHelper';

export function* dataAutomation(action) {
    let requestUrl = `${REPORT}/crawler/initiate`;
    try {
        const result = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(CommonCaseActions.dataAtuomationInitiateSuccess(result.data));
    } catch (err) {
        yield put(CommonCaseActions.dataAtuomationInitiateFailure(err.response))
    }
}
export function* dataAutomationInitiate() {
    yield takeLatest(CommonCaseActions.DATA_AUTOMATION_INITIATE, dataAutomation);
}


export function* kycDataAutomation(action) {
    let requestUrl = `${REPORT}/kyc/crawler/initiate`;
    try {
        const result = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(CommonCaseActions.kycDataAtuomationInitiateSuccess(result.data));
    } catch (err) {
        yield put(CommonCaseActions.kycDataAtuomationInitiateFailure(err.response))
    }
}
export function* kyDataAutomationInitiate() {
    yield takeLatest(CommonCaseActions.KYC_DATA_AUTOMATION_INITIATE, kycDataAutomation);
}

export function* kycCrawlerStatus(action) {
    let requestUrl = `${REPORT}/kyc/crawler/status?cachekill=`+Math.random();
    try {
        const result = yield call(request, requestUrl, { data: action.data,method: 'POST', headers: HTTP_HEADERS });
        yield put(CommonCaseActions.getKycCrawlerStatusSuccess(result.data));
    } catch (err) {
        yield put(CommonCaseActions.getKycCrawlerStatusFailure(err.response))
    }
}
export function* getKycCrawlerStatus() {
    yield takeLatest(CommonCaseActions.GET_KYC_CRAWLER_STATUS, kycCrawlerStatus);
}


export function* crawlerStatus(action) {
    let requestUrl = `${REPORT}/crawler/status?cachekill=`+Math.random();
    try {
        const result = yield call(request, requestUrl, { data: action.data,method: 'POST', headers: HTTP_HEADERS });
        yield put(CommonCaseActions.getCrawlerStatusSuccess(result.data));
    } catch (err) {
        yield put(CommonCaseActions.getCrawlerStatusFailure(err.response))
    }
}
export function* getCrawlerStatus() {
    yield takeLatest(CommonCaseActions.GET_CRAWLER_STATUS, crawlerStatus);
}

export function* crawlerMarkfailur(action) {
    let requestUrl = `${REPORT}/crawler/updateStatus`;
    try {
        const result = yield call(request, requestUrl, { data: action.data,method: 'POST', headers: HTTP_HEADERS });
        yield put(CommonCaseActions.getCrawlerMarkasfailSuccess(result.data));
    } catch (err) {
        yield put(CommonCaseActions.getCrawlerMarkasfailFailure(err.response))
    }
}
export function* getCrawlerMarkasfail() {
    yield takeLatest(CommonCaseActions.GET_CRAWLER_MARKASFAIL, crawlerMarkfailur);
}

export function* initiateLegalCrawler(action){
    let requestUrl = `${REPORT}/legal/api/initiate`;
    try {
        const result = yield call(request, requestUrl, { data: action.data,method: 'POST', headers: HTTP_HEADERS });
        yield put(CommonCaseActions.legalCrawlerResponse({status :"SUCCESS", data : result.data }));
    } catch (err) {
        yield put(CommonCaseActions.legalCrawlerResponse({status :"FAILURE", data : err.response }));
    }
}


export function* startLegalCrawler(){
    yield takeLatest(CommonCaseActions.INTITIATE_LEGAL_CRAWLER, initiateLegalCrawler);
}


export function* legalSectionTemplateRequestSaga(action){
    let requestUrl = `${REPORT}/section/sectionDataTableType?sectionDataTableType=${action.data.sectionDataTableType}`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(CommonCaseActions.legalSectionTemplateResponse( result.data ));
    } catch (err) {
        yield put(CommonCaseActions.legalSectionTemplateResponse({}));
    }
}

export function* legalSectionTemplateRequest(){
    yield takeLatest(CommonCaseActions.LEGAL_SETCION_TEMPLATES_REQUEST, legalSectionTemplateRequestSaga);
}


export function* nicSearchRequestSaga(action){
    let requestUrl = `${REPORT}/nic/search/${action.data}`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(CommonCaseActions.nicSearchResponse( result.data ));
    } catch (err) {
        yield put(CommonCaseActions.nicSearchResponse({}));
    }
}

export function* nicSearchRequest(){
    yield takeLatest(CommonCaseActions.NIC_SEARCH_REQUEST, nicSearchRequestSaga);
}

export function* initiateZigramRequest(action){
    let requestUrl = `${REPORT}/crawler/zigram`;

    const { zigramRequestbody, associationExcelFile } = action.data;
    const formData = new FormData();
    formData.append('zigramRequestDto', new Blob([JSON.stringify(zigramRequestbody)], { type: 'application/json' }));
    formData.append('associationExcelFile', associationExcelFile);
    try {
        const result = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(CommonCaseActions.zigramSearchResponse({status :"SUCCESS", data : result.data }));
    } catch (err) {
        yield put(CommonCaseActions.zigramSearchResponse({status :"FAILURE", data : err.response }));
    }
}

export function* zigramSearchRequest(){
    yield takeLatest(CommonCaseActions.INTITIATE_ZIGRAM_CRAWLER, initiateZigramRequest);
}

export function* initiateZigramExcelRequest(action){
    let requestUrl = `${REPORT}/zigram/generateExcel`;
    try {
        const result = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(CommonCaseActions.zigramExcelResponse({status :"SUCCESS", data : result.data }));
    } catch (err) {
        yield put(CommonCaseActions.zigramExcelResponse({status :"FAILURE", data : err.response }));
    }
}

export function* zigramExcelRequest(){
    yield takeLatest(CommonCaseActions.INTITIATE_ZIGRAM_EXCEL_REQUEST, initiateZigramExcelRequest);
}


export function* additionalLegalTemplateRequest(action) {
    let requestURL = `${CORE_API}/legal/api/additional/template`;

    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(CommonCaseActions.additionalLegalTemplateResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(CommonCaseActions.additionalLegalTemplateResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* additionalLegalTemplate() {
    yield takeLatest(CommonCaseActions.ADDITIONAL_LEGAL_TEMPLATE_REQUEST, additionalLegalTemplateRequest);
}

export function* additionalLegalUploadRequest(action) {
    let requestURL = `${CORE_API}/legal/api/additional/upload`;

    try {
        const data = yield call(request, requestURL, {data: action.data, method: 'POST', headers: HTTP_HEADERS_FORMDATA});
        yield put(CommonCaseActions.additionalLegalUploadResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(CommonCaseActions.additionalLegalUploadResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* additionalLegalUpload() {
    yield takeLatest(CommonCaseActions.ADDITIONAL_LEGAL_UPLOAD_REQUEST, additionalLegalUploadRequest);
}

export function* amlPepTemplateRequest(action) {
    let requestURL = `${CORE_API}/zigram/additional/template`;

    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(CommonCaseActions.amlPepTemplateResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(CommonCaseActions.amlPepTemplateResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* amlPepTemplate() {
    yield takeLatest(CommonCaseActions.AML_PEP_TEMPLATE_REQUEST, amlPepTemplateRequest);
}

export function* initiateMasterDataSyncSaga(action) {
    const { counterpartyId, caseId } = action.data;
    const requestUrl = `${CORE_API}/mca-sync/master-data/${counterpartyId}?caseId=${encodeURIComponent(caseId)}`;
    try {
        const result = yield call(request, requestUrl, {
            method: 'POST',
            headers: HTTP_HEADERS
        });
        yield put(CommonCaseActions.masterDataSyncResponse({
            status: "SUCCESS",
            data: result.data,
            counterpartyId
        }));
    } catch (err) {
        yield put(CommonCaseActions.masterDataSyncResponse({
            status: "FAILURE",
            data: err.response || err.message,
            counterpartyId
        }));
    }
}

export function* masterDataSyncRequest() {
    yield takeLatest(CommonCaseActions.INITIATE_MASTER_DATA_SYNC, initiateMasterDataSyncSaga);
}

export function* itrAnalysisResyncSaga(action) {
    const requestUrl = `${REPORT}/crawler/itr-analysis/resync`;
    try {
        const result = yield call(request, requestUrl, {
            method: 'POST',
            headers: HTTP_HEADERS,
            data: action.data
        });
        yield put(CommonCaseActions.itrAnalysisResyncResponse({
            status: "SUCCESS",
            data: result.data,
            at: Date.now()
        }));
    } catch (err) {
        const responseData = err?.response?.data;
        const message = (responseData && responseData.message) || err?.message || "Failed to resync ITR analysis";
        yield put(CommonCaseActions.itrAnalysisResyncResponse({
            status: "FAILURE",
            message,
            at: Date.now()
        }));
    }
}

export function* itrAnalysisResync() {
    yield takeLatest(CommonCaseActions.ITR_ANALYSIS_RESYNC, itrAnalysisResyncSaga);
}